<!-- Bar Line Combo Chart - Chart.js Implementation -->
<div class="bar-line-combo-chart-container" #chartContainer>
  <!-- Chart Wrapper -->
  <div class="chart-wrapper">
    <!-- Chart.js Combo Chart -->
    <div class="chart-section">
      <div class="chart-container">
        <canvas baseChart 
          [data]="comboChartData" 
          [type]="comboChartType" 
          [options]="comboChartOptions"
          (chartClick)="onChartSelect($event)"
          (chartHover)="onChartActivate($event)">
        </canvas>
      </div>
    </div>
  </div>

  <!-- Custom Legend - Only show for multiple datasets -->
  <div class="bar-line-combo-chart-legend" *ngIf="legend && comboChartData.datasets && comboChartData.datasets.length > 1">
    <div class="legend-title" *ngIf="legendTitle">{{ legendTitle }}</div>
    <div class="legend-items">
      <!-- Bar Legend -->
      <div class="legend-item" *ngIf="comboChartData.datasets[0]">
        <div class="legend-color bar-color"></div>
        <span class="legend-label">{{ comboChartData.datasets[0].label }}</span>
      </div>
      <!-- Line Legends -->
      <div class="legend-item" *ngFor="let dataset of comboChartData.datasets.slice(1)">
        <div class="legend-color line-color" [style.background-color]="dataset.borderColor"></div>
        <span class="legend-label">{{ dataset.label }}</span>
      </div>
    </div>
  </div>
</div>